module.exports = __webpack_public_path__ + "static/media/vkverified.0063cefb.svg";